import _SessionPlan from './model';
import create from './create';

export const SessionPlan = _SessionPlan;

SessionPlan.create = create;

export default SessionPlan;



// WEBPACK FOOTER //
// ./data/SessionPlans/model/index.js